export const supportedDocuments = {
  supported_documents: `Supported documents`,
  document_name: `Document name`,
  expiry_date: `Expiry date`,
  upload_support_document: `Upload support document`,
  upload_prefix: `Upload`,
  upload_and_manage_support_documents: `Upload and manage support documents`,
  set_document_expiry: `Set document expiry`,
  partyDocument_expires_on: `Expires on {{expiryDate}}`,
  delete_document: `Delete document`,
  this_action_cannot_be_undone: `This action cannot be undone`,
  previous_page: `Previous page`,
  next_page: `Next page`,
  suppler_document_expired: `The supplier supported document has expired`,
  update_support_document_in_profile_page: `Please update the support document from the supplier profile page.`,
  document_updated_successfully: `Document updated successfully`,
  document_uploaded_successfully: `Document uploaded successfully`,
  document_deleted_successfully: `Document deleted successfully`,
  update_document: `Update document`,
  save_document: `Save document`,
  partyDocument_expired_on: `Expired on {{expiryDate}}`,
  expiry_date_is_required: `Expiry date is required`,
  document_expiry_date_required: `Document expiry date is required`,
  document_can_only_be_updated_3_days_before_expiry_or_after_expiry: `Document can only be updated 3 days before expiry or after expiry`,
  expiry_date_cannot_be_less_than_current_date: `Expiry date cannot be earlier than the current date`,
  upload_new: `Upload new`,
  profile_updated: `Profile updated`,
};
